var TextTeasers = (() => null);

export default TextTeasers;
